(function ($, Cobalt, undefined) {
    var _managerModal;
    var _modalOpen = false;
    Cobalt.Smilies = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.Listing, name: "Cobalt.Listing" }];
        },

        initialize: function () {
        },
        smiliesReady: function () {

        },
        showLoading: function () {
            _managerModal.find('#smilies-manager').addClass('loading');
        },
        hideLoading: function () {
            _managerModal.find('#smilies-manager').removeClass('loading');
        },
        hideModal: function () {
            if (_managerModal.length > 0) {
                _managerModal.dialog("destroy");
                _managerModal.remove();
                _modalOpen = false;
                $("body").off("click", "#smiley-listing > li");
            }
        },
        showModal: function (ed) {            

            $("body").on("click", "#smiley-listing > li", function (e) {
                e.preventDefault();
                var $smiley = $(this);
                var $smileString = $smiley.attr("data-text-replacement");
                if (ed && tinyMCE && tinyMCE.editors.length) {
                    ed.selection.moveToBookmark(ed.selection.getBookmark());
                    ed.execCommand('mceInsertContent', false, $smileString);
                } else {
                    $.markItUp({ replaceWith: $smileString });
                }
                Cobalt.Smilies.hideModal();
            });

            if (_modalOpen) {
                return;
            }

            _modalOpen = true;

            _managerModal = $('<div id="smiley-modal">');
            _managerModal.dialog({
                modal: true,
                height: 275,
                width: 330,
                title: "Insert a Smiley",
                resizable: false,
                close: function (event, ui) {
                    $(event.target).dialog("destroy");
                    $(event.target).remove();
                    _modalOpen = false;
                }
            });
            _managerModal.parent().center();

            _managerModal.mask();

            $.get(Cobalt.Routes.Instance.SmileyGetSmilies(), function (data) {
                var $smiliesList = $(data);
                _managerModal.unmask();
                _managerModal.append($smiliesList);

                Cobalt.triggerHtmlInsert(_managerModal);

                _managerModal.dialog({ position: 'center' });

                var i;
                var tabsArray = [];
                var ulWidth = 0;
                var tabTracker = 0;
                var currentTabWidthTotal = 0;
                var tabsContainerWidth = $('#smilies-manager').outerWidth() - $('#smilies-manager button#right-arrow').outerWidth();

                $('#smiley-modal ul.tabbed-tabs li').each(function (i) {
                    tabsArray[i] = $(this).width();
                });

                for (i = 0; i < tabsArray.length; i++) {
                    ulWidth = tabsArray[i] + ulWidth;
                }

                $('#smilies-manager button#left-arrow').click(function () {
                    if (tabTracker == 0 || ulWidth < tabsContainerWidth) {
                        return false;
                    } else {
                        tabTracker--;
                        $('#smiley-modal ul.tabbed-tabs').css('left', '-' + (currentTabWidthTotal - tabsArray[tabTracker]) + 'px');
                        currentTabWidthTotal = currentTabWidthTotal - tabsArray[tabTracker];
                    }
                });

                $('#smilies-manager button#right-arrow').click(function () {
                    if (ulWidth - (currentTabWidthTotal + tabsArray[tabTracker]) <= tabsContainerWidth) {
                        $('#smiley-modal ul.tabbed-tabs').css('left', '-' + (ulWidth - tabsContainerWidth + 18) + 'px');
                    } else if (ulWidth < tabsContainerWidth) {
                        return false;
                    } else {
                        $('#smiley-modal ul.tabbed-tabs').css('left', '-' + (tabsArray[tabTracker] + currentTabWidthTotal) + 'px');
                        tabTracker++;
                        currentTabWidthTotal = tabsArray[tabTracker - 1] + currentTabWidthTotal;
                    }
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Smilies.js